/* WorkViewComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./WorkViewRenderer");

class WorkViewComponent extends EventEmitter {
    constructor(logger, gameEditor, triggerTypeInstanceId) {
        super();

        this._logger = logger;
        this._gameEditor = gameEditor;
        this._triggerTypeInstanceId = triggerTypeInstanceId;

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._logger = undefined;
        this._gameEditor = undefined;
        this._triggerTypeInstanceId = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    get triggerTypeInstanceId() {
        return this._triggerTypeInstanceId;
    }

    getJobList() {
        return [
            {
                id: "row1",
                activityType: { activityType: "system" },
                snapshot: { snapshot: "12/12/2017 12:12:12" },
                description: { description: `Phase 0.1` },
                status: { loading: true },
                actions: { viewMore: true }
            },
            {
                id: "row2",
                activityType: { activityType: "system" },
                snapshot: { snapshot: "11/11/2017 11:11:11" },
                description: { description: `Phase 0.2` },
                status: { clean: true },
                actions: { viewMore: true }
            },
            {
                id: "row3",
                activityType: { activityType: "system" },
                snapshot: { snapshot: "10/10/2017 10:10:10" },
                description: { description: `Phase 0.3` },
                status: { error: true },
                actions: { viewMore: true }
            }
        ];
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = WorkViewComponent;

WorkViewComponent.$displayDetails = {
    type: "View",
    name: "Works",
    icon: "common.edit",
    shown: false,
    title: "Works"
};
